import type { ClientError } from "graphql-request"

import type { ListQuery, NonNullListQueryNode, Nullable } from "./types"
import { notEmpty } from "./utils"

export const getListQueryNodes = <TNode extends Record<string, unknown>>(
  listQuery: Nullable<ListQuery<TNode>>,
): NonNullListQueryNode<ListQuery<TNode>>[] => {
  return listQuery?.edges?.map(edge => edge?.node).filter(notEmpty) || []
}

export type QueryError = Error | ClientError

export const isQueryError = (error: unknown): error is QueryError =>
  error instanceof Error || (error instanceof Object && "response" in error)

export const getQueryErrorMessage = (error: QueryError): string => {
  let { message } = error

  if ("response" in error) {
    const { errors } = error.response
    if (errors?.[0]) {
      message = errors[0].message
    }
  }

  return message
}
